exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".waiting-room-sidebar--2PMrTqf6S9XvLVZvJO6PbD {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 2px;\n}\n\n.waiting-room-sidebar--7-8zST0lr_Zoag69ZuUqV {\n  font-size: .75rem;\n  line-height: 1.5rem;\n  color: #696b6b;\n  margin-right: .25rem;\n  flex-shrink: 0;\n}\n\n.waiting-room-sidebar--16aW9SFpY9sht43GEBgPaz {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  font-size: .75rem;\n  line-height: 1.5rem;\n  color: #000;\n}\n", ""]);

// exports
exports.locals = {
	"sidebarItem": "waiting-room-sidebar--2PMrTqf6S9XvLVZvJO6PbD",
	"sidebarItem": "waiting-room-sidebar--2PMrTqf6S9XvLVZvJO6PbD",
	"sidebarLabel": "waiting-room-sidebar--7-8zST0lr_Zoag69ZuUqV",
	"sidebarLabel": "waiting-room-sidebar--7-8zST0lr_Zoag69ZuUqV",
	"sidebarValue": "waiting-room-sidebar--16aW9SFpY9sht43GEBgPaz",
	"sidebarValue": "waiting-room-sidebar--16aW9SFpY9sht43GEBgPaz"
};